const experimentConfig = {
  globalExperiment: {
    experimentId: 'Q4KMAh3BQ4qNUNsdMXdprg',
    running: true,
    loadingCover: true,
    sites: [
      'themeforest',
      'graphicriver',
      'codecanyon',
      'photodune',
      'threedocean',
      'videohive',
      'audiojungle'
    ],
    variantsWeights: [1, 9],
    variants: {
      0: {
        globalExperiment: false,
        homepageNewDesign: false
      },
      1: {
        globalExperiment: true,
        homepageNewDesign: true,
        categoryPageBlocksB: true
      }
    }
  },
  tfHomepageValuePropExperiment: {
    experimentId: '0gpMpN7mQiaiGrxe0BiMEg',
    running: true,
    sites: ['themeforest'],
    loadingCover: true,
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {},
      1: {
        homePageBlocksB: true
      },
      2: {
        homePageBlocksC: true
      }
    }
  }
}

export default experimentConfig
